import React from 'react';
import MonitoringPriorityBadge from 'components/atoms/monitoring_priority_badge';
import { MONITORING_PRIORITIES, MonitoringPriority } from 'services/monitoring_settings';
import { MONITORING_SOUNDS, playMonitoringSound } from 'services/monitoring_sounds';
import { Container } from './styles';

interface MonitoringPrioritySoundsProps {
  sounds: Record<MonitoringPriority, string>;
  onChange: (priority: MonitoringPriority, sound: string) => void;
}

const MonitoringPrioritySounds = ({ sounds, onChange }: MonitoringPrioritySoundsProps) => (
  <Container>
    <p className="mb-2">Alterar som do aviso sonoro</p>
    <div className="d-flex flex-wrap">
      {MONITORING_PRIORITIES.map((priority) => (
        <div className="sound-option" key={priority.value}>
          <MonitoringPriorityBadge priority={priority.value} />
          <select
            className="custom-select custom-select-sm"
            aria-label={`Som da ${priority.label.toLowerCase()}`}
            value={sounds[priority.value]}
            onChange={(event) => onChange(priority.value, event.target.value)}
          >
            {MONITORING_SOUNDS.map((sound) => (
              <option key={sound.value} value={sound.value}>
                {sound.label}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            aria-label={`Ouvir o som da ${priority.label.toLowerCase()}`}
            title="Ouvir"
            onClick={() => playMonitoringSound(sounds[priority.value])}
          >
            <i className="material-icons">volume_up</i>
          </button>
        </div>
      ))}
    </div>
  </Container>
);

export default MonitoringPrioritySounds;
